import React, { useEffect, useReducer, useState } from "react";
import { Modal } from 'react-bootstrap'
import { func } from '../../Utilities/logFunc'
import { getAllFreeAvatar, getConstantProfile, getCountryList, getStateList, sendOTPN, validateOtpN } from '../../Utilities/controller'
import { errors } from '../../Utilities/error'
import { routes } from '../../Utilities/routesFb'
import { useNavigate } from 'react-router'
import { url } from '../../Utilities/url'
import Loader from '../Common/Loader'
import { logout } from '../../Utilities/logout'
import { toast, ToastContainer } from 'react-toastify'
import LoginLandingPage from '../LandingPage/LoginLandingPage'
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { async } from 'q'
import { eventTracking } from "../../firebaseAnalytics";
import { events } from "../../Utilities/appEvents";
import { requestUpdateProfile } from '../../Utilities/withJwtController'
import { singularSdk } from "singular-sdk";
import { useProfileDataContext } from '../HomePage/ProfileContext'
import { INITIAL_STATE_REG, registerReducer } from "./SignupReducer";
import verifiedsvg from "../../assets/images/verified-symbol-icon.svg";
const Avartar = () => {
  const navigate = useNavigate()
  const [avatar, setAvatar] = useState([])
  const [show, setShow] = useState(true);
  const [userName, setUserName] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [avatarId, setAvatarId] = useState('')
  const [avatarError, setAvatarError] = useState('')
  const [country, setCountry] = useState(null)
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [isSendClicked, setIsSendClicked] = useState(false);
  const [countryList, setCountryList] = useState([])
  const [stateList, setStateList] = useState([])
  const [state, setState] = useState()
  const [index, setIndex] = useState()
  const [stateIndex, setStateIndex] = useState()
  const [loginType, setLoginType] = useState(false)
  const [liteProfile, setLiteProfile] = useState()
  const [email, setEmail] = useState(null)
  const [phone, setPhone] = useState(null)
  const [erroremail, setErrorEmail] = useState(null)
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [registerInput, setRegisterInput] = useState({
    mobileNumber: "",
    countryOption: "",
    code: "IN"
  });
  const [otpError, setOtpError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [otp, setOtp] = useState(""); // for OTP input
  const [isemail, setisEmail] = useState(false)
  const [isphone, setisPhone] = useState(false)
  const [timer, setTimer] = useState(60);
  const [resendAvailable, setResendAvailable] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  // const [userCountryObj, setUserCountryObj] = useState(null);
  const [stateA, setStateA] = useState(null);
  const [stateB, setStateB] = useState(null);
  const [stateAError, setStateAError] = useState('');
  const [stateBError, setStateBError] = useState('');
  const { t } = useTranslation();
  const countyId = localStorage.getItem('country')
  const onChangeHandler = (e) => {
    setUserName(prev => e.target.value)
    setError('')
  }
  const callToOTPRequestAPISignup = async () => {

    setIsSendClicked(true);
    const payload = {
      phone: registerInput?.mobileNumber,
      phoneCode: country?.dialingCode,  // pick code from selected country
    };

    console.log("Payload:", payload);

    try {
      const res = await sendOTPN(payload);

      console.log("API Raw Response:", res);
      // ✅ See exactly what keys it has
      console.log("API keys:", Object.keys(res));

      // ✅ Use res directly

      if (res?.data?.success) {
        setIsOTPSent(true);
        setPhoneError('');
        setResendAvailable(false);
        setTimer(60);
        if (intervalId) clearInterval(intervalId);

        const id = setInterval(() => {
          setTimer(prev => {
            if (prev <= 1) {
              clearInterval(id);
              setResendAvailable(true);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        setIntervalId(id);

      } else {
        console.log("API failure:", res?.response?.data?.errors[0]?.msg);

        if (res?.errors?.length) {
          console.log("API error msg:", res.errors[0].msg);
          setPhoneError(res?.response?.data?.errors[0]?.msg);
        } else {
          console.log("No errors array. Using fallback.");
          setPhoneError(res?.response?.data?.errors[0]?.msg);
        }
      }

    } catch (err) {
      console.log("API Exception:", err);
      setPhoneError("Something went wrong. Please try again.");
    }
  };
  const handleValidateOtp = async () => {
    try {
      const payload = {
        phone: registerInput?.mobileNumber,
        phoneCode: country?.dialingCode,
        otp: otp,
      };

      console.log("Validating OTP with payload:", payload);

      const response = await validateOtpN(payload);

      console.log("OTP Validation Response:", response);

      if (response?.data?.success) {
        localStorage.setItem("verifiedPhoneNumber", registerInput.mobileNumber);
        localStorage.setItem("verifiedCountry", JSON.stringify(country)); // ✅ store country object

        setIsPhoneVerified(true); // your existing
        setIsOTPVerified(true);   // ✅ NEW
        setPhoneError('');

      } else {
        setPhoneError('Invalid OTP, please try again.');
      }

    } catch (error) {
      console.error("OTP validation failed:", error);
      setOtpError('OTP validation failed. Please try again.');
    }
  };
  const onChangeEmail = (e) => {
    const emailtext = e.target.value;

    // Always update the state, even if empty or invalid
    setEmail(emailtext);

    // Then validate — but only show error if non-empty AND invalid
    if (emailtext.trim() === '') {
      setErrorEmail(null); // no error when empty
    } else {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailtext);
      if (isValidEmail) {
        setErrorEmail(null); // valid email => no error
      } else {
        setErrorEmail('Please enter valid email'); // invalid email
      }
    }
  };


  // ✅ At top of your component:
  const verifiedCountry = JSON.parse(localStorage.getItem('verifiedCountry'));

  useEffect(() => {
    const verifiedNumber = localStorage.getItem("verifiedPhoneNumber");

    if (verifiedNumber) {
      setRegisterInput(prev => ({
        ...prev,
        mobileNumber: verifiedNumber
      }));
      setIsOTPVerified(true);
      setIsPhoneVerified(true);

      // ✅ Only set country if you stored it
      if (verifiedCountry) {
        const matched = countryList.find(c => c.value === verifiedCountry);
        if (matched) setCountry(matched);
      }
    }
  }, [countryList]);

  const fetchCountry = async () => {
    try {
      const res = await getCountryList();
      if (res) setCountryList(res.list);

      let selectedCountry = null;

      if (verifiedCountry) {
        selectedCountry = verifiedCountry;
      } else if (countyId !== 'null' && countyId != null) {
        selectedCountry = res.list.find(item => item._id.toString() === countyId);
      }
      // 🚫 REMOVE fallback India logic

      if (selectedCountry) {
        setCountry(selectedCountry);
      } else {
        setCountry(null); // ✅ force blank if no match
      }

    } catch (error) {
      toast.error(error?.response?.errors?.[0]?.msg || "Something went wrong");
    }
    fetchState();
  };




  const onChangePhone = (e) => {
    setPhone(prev => e.target.value)
    setError('')
  }

  const handleClose = () => {
    setShow(false)
    logout()
  };
  const fetchAvatar = async () => {
    try {
      const res = await getAllFreeAvatar()
      func('avatar^^^^^^^^response', res)
      setAvatar(res?.data?.list)
      setLoading(false)

    }
    catch (error) {
      setLoading(false)
      if (error?.response?.data?.errors?.[0]?.code == "middlewares.token_parser.validation.token_invalid" || error?.response?.data?.errors?.[0]?.code == "middlewares.token_parser.validation.token_expired")
        //logout()
        setError(error?.response?.data?.errors?.[0]?.msg)
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg)
    }
  }


  const fetchState = async () => {
    try {
      const res = await getStateList({
        skip: 0,
        limit: 100,
        sortBy: "name",
        sort: "asc",
      });
      // console.log(res);
      if (res.data.success) {
        setStateList(res.data.list)
        // setTimeout(() => {
        console.log(res.data.list[0]);
        setState(res.data.list[0])
        // }, 2000);
      }
      // if (res) setCountryList((prev) => res?.list);
      // setCountryOption(prev=> res?.list[2].dialingCode)
      // let index = null;
      // res?.list?.filter((item, ind) => {
      //   if (item?.dialingCode == "+91") {
      //     index = ind;
      //     return index;
      //   }
      // });
      // func("index", index);
      // setIndex(index)
      // setCountry(res?.list?.[index]?._id)
    } catch (error) {
      toast.error(error?.response?.errors[0]?.msg)
    }
  }
  const fetchAccountProfile = async () => {
    try {
      const data = await getConstantProfile();

      if (data?.data) {
        setLiteProfile(data?.data)
        console.log(data?.data)
        localStorage.setItem("profile", JSON.stringify(data?.data))
      }

    } catch (error) {
      toast.error(error?.response?.errors?.[0]?.msg)
    }
  }
  useEffect(() => {



    // if (localStorage.getItem("phone") !== undefined && localStorage.getItem("phone") !== null && localStorage.getItem("phone") !== '') {
    //   // console.log("FirstPHONE", localStorage.getItem("phone"));
    //   setPhone(localStorage.getItem("phone"));
    //   setisPhone(true);
    // }

    // if (localStorage.getItem("email") !== undefined && localStorage.getItem("email") !== null && localStorage.getItem("email") !== '') {
    //   // console.log("FirstEMAIL", localStorage.getItem("email"));
    //   setEmail(localStorage.getItem("email"));
    //   setisEmail(true);
    // }
    setLoading(true)
    fetchCountry()
    fetchAvatar()
    fetchAccountProfile()
    let loginTypeFetch = JSON?.parse(localStorage.getItem("loginInfo"))?.username
    if (isNumeric(loginTypeFetch)) {
      setLoginType(true)
    }
    else {
      setLoginType(false)
    }
  }, [])
  useEffect(() => {
    console.log(liteProfile)
    if (liteProfile) {
      if (liteProfile?.item?.phone !== undefined && liteProfile?.item?.phone !== null && liteProfile?.item?.phone !== '') {
        // console.log("FirstPHONE", liteProfile?.phone);
        setPhone(liteProfile?.item?.phone);
        setisPhone(true);
      }

      if (liteProfile?.item?.email !== undefined && liteProfile?.item?.email !== null && liteProfile?.item?.email !== '') {
        console.log("FirstEMAIL", liteProfile?.item?.email);
        setEmail(liteProfile?.item?.email);
        setisEmail(true);
      }
    }
  }, [liteProfile])
  useEffect(() => {
    // console.log(">>EMAIL", email, isemail)
    // console.log(">>PHONE", phone, isphone)

  }, [email, isemail, phone, isphone])

  const handleEditPhone = () => {
    setIsSendClicked(false);    // back to Send state
    setIsOTPSent(false);        // hide OTP field
    setIsOTPVerified(false);    // reset verified state if needed
    setOtp('');                 // clear OTP input
  };
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string)
  useEffect(() => {
    const savedPhone = localStorage.getItem('phone');
    if (savedPhone) {
      setPhone(savedPhone);
      setIsPhoneVerified(true); // ✅ mark as verified automatically
    }
  }, []);
  const submitHandler = (e) => {
    e.preventDefault();

    setError('');
    setAvatarError('');
    setErrorEmail('');
    setPhoneError('');
    setStateAError('');
    setStateBError('');

    let isValid = true;

    if (!isOTPVerified && !isPhoneVerified) {
      setPhoneError('Please verify your mobile number');
      isValid = false;
    }


    if (!userName || userName.trim() === '') {
      setError(t("error_enter_gamerji_username"));
      isValid = false;
    }

    if (!avatarId || avatarId === '') {
      setAvatarError(t('error_Select_your_Gamerji_Avatar'));
      isValid = false;
    }

    if (!email || email.trim() === '') {
      setErrorEmail('Please enter email');
      isValid = false;
    }

    if (
      !isemail && stateList.length > 0 &&
      (country?.dialingCode === "+91" || country?.dialingCode === "91") &&
      !stateA
    ) {
      setStateAError('Please select state');
      isValid = false;
    }

    if (
      stateList.length > 0 &&
      isCountrySelected &&
      (country?.dialingCode === "+91" || country?.dialingCode === "91") &&
      !stateB
    ) {
      setStateBError('Please select state');
      isValid = false;
    }


    if (isValid) {
      callCreateProfile();
    }
  };

  const callCreateProfile = async () => {
    var payload = {
      gamerjiName: userName,
      isDetailsFilled: true,
      avatar: avatarId,
    };

    if (email !== 'null' && email !== null && email !== '' && email !== undefined) {
      payload.email = email;
    }
    if (phone !== 'null' && phone !== null && phone !== '' && phone !== undefined) {
      payload.phone = phone;
      payload.phoneCode = country?.dialingCode;
    }

    if (countyId === 'null' || countyId === null) {
      if (country?.dialingCode === "+91" || country?.dialingCode === "91") {
        payload.address = { country: country._id, state: state._id };
      } else {
        payload.address = { country: country._id };
      }
      payload.isEmail = true;
    } else {
      payload.address = { country: countyId, state: state._id };
    }

    setLoading(true);

    try {
      const res = await requestUpdateProfile(payload);

      if (res?.data?.success) {
        // ✅ success tracking
        eventTracking(events.SIGNUP_COMPLATE, {
          GJ_GamerJiName: userName,
          GJ_AvatarID: avatarId,
          GJ_Country: payload.address ? payload.address.country : "",
          GJ_State: payload.address ? payload.address.state : "",
          GJ_UserID: res?.data?.user_id,
        });

        singularSdk.event("Create_Profile_btn", {
          GJ_GamerJiName: userName,
          GJ_AvatarID: avatarId,
          GJ_Country: payload.address ? payload.address.country : "",
          GJ_State: payload.address ? payload.address.state : "",
          GJ_UserID: res?.data?.user_id
        });

        localStorage.removeItem("isDetailsFilled");
        toast.success(res?.data?.msg);

        if (localStorage.getItem('code')) {
          window.location.href = "/" + routes.home + `?code=${localStorage.getItem('code')}`;
        } else {
          window.location.href = "/" + routes.home;
        }

      } else {
        // ✅ handle API validation errors — NO toast
        setError('');
        setErrorEmail('');
        setAvatarError('');
        setPhoneError('');

        const apiErrors = res?.response?.data?.errors || [];

        apiErrors.forEach(err => {
          switch (err.code) {
            case "account.validation.gamerjiname_not_available":
              setError(err.msg);
              break;
            case "account.validation.email_invalid":
            case "account.validation.profile.email_already_exists":
              setErrorEmail(err.msg);
              break;
            case "account.validation.avatar_invalid":
              setAvatarError(err.msg);
              break;
            case "account.validation.phone_not_verified":
              setPhoneError(err.msg);
              break;

            default:
              console.warn("Unhandled API error:", err);
          }
        });
      }

    } catch (error) {
      func("error", error);
      console.log(error);

      setError('');
      setErrorEmail('');
      setAvatarError('');
      setPhoneError('');

      const apiErrors = error?.response?.data?.errors || [];

      apiErrors.forEach(err => {
        switch (err.code) {
          case "account.validation.gamerjiname_not_available":
            setError(err.msg);
            break;
          case "account.validation.email_invalid":
            setErrorEmail(err.msg);
            break;
          case "account.validation.avatar_invalid":
            setAvatarError(err.msg);
            break;
          case "account.validation.phone_not_verified":
            setPhoneError(err.msg);
            break;

          default:
            console.warn("Unhandled API error:", err);
        }
      });
    }

    setLoading(false);
  };
  const customStyles = {

    // menu: (defaultStyles, state) => ({
    //   ...defaultStyles,
    //   // backgroundColor: "red",
    //   minHeight:'15rem',
    //   backgroundColor: "var(--secondary-color-emphasis)",
    // }),

    option: (defaultStyles, state) => ({
      ...defaultStyles,
      color: state.isSelected ? "#000" : "#000",
      backgroundColor: state.isSelected
        ? "var(--secondary-color-emphasis) !important"
        : "var(--secondary-color-emphasis)",
      height: '2.5rem',
      "&:hover": {
        // color:'var(--dashboard-bg)',
        backgroundColor: 'red',

      },
      padding: "0.65rem 1.25rem",
      borderRadius: '20px',


    }),

    control: (defaultStyles) => ({
      ...defaultStyles,
      backgroundColor: "var(--secondary-color-emphasis)",
      padding: "0.5rem",

      boxShadow: "none",
      borderRadius: "50px",
      display: "flex",
      alignItems: "center",
      caretColor: 'transparent',
      minHeight: '3.75rem',
      border: '1px solid var(--body-color)'

    }),
    singleValue: (defaultStyles) => ({
      ...defaultStyles,
      color: "#000",
      width: "15rem",
      marginRight: "0.75rem",
      padding: "0.35rem",

    }),
    indicatorsSeparator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#000",
      display: "none",
    }),
    indicatorContainer: (defaultStyles) => ({
      ...defaultStyles,
      padding: "0",
      backgroundColor: "red",
    }),

    input: (defaultStyles) => ({
      ...defaultStyles,
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "1.85rem",

    }),
    dropdownIndicator: (defaultStyles) => ({

      color: '#000',
      width: '1.5rem',
      height: '1.5rem',
      padding: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    })
  };


  const onClickHandler = (item) => {

    eventTracking(events.avatar_selected, { GJ_AvatarID: item })
    setAvatarId(item)
    setAvatarError('')
  }
  // console.log(isLoading);
  const customFilter = (option, searchText) => {
    // console.log(option, searchText)
    if (
      option.data.name.toLowerCase().includes(searchText.toLowerCase())

    ) {
      return true;
    } else {
      return false;
    }
  }
  const stateCustomFilter = (option, searchText) => {
    // console.log(option, searchText)
    if (
      option.data.name.toLowerCase().includes(searchText.toLowerCase())

    ) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <LoginLandingPage>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="auth-modal avatarModal modal fade "
        centered
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header> */}
        <Modal.Body >
          {/* <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          ></button> */}

          <div className="row justify-content-center py-4">
            <div className="col-12">
              <ToastContainer />
              <div className="tab-content auth-content text-center">
                <h1 className="h2  pb-5 text-dark">{t("login.welcome_to_gamerji")}</h1>
                <h5 className="mb-3 text-dark">
                  {t("login.identity")}
                </h5>
                <div className="row justify-content-center mb-5 text-dark d-flex mt-3">
                  <div className="d-flex flex-column align-items-center mt-3">
                    <label
                      for="inputCoutryCode"
                      className="form-label text-nowrap"
                    >
                      {`Username`}
                    </label>
                    <div className="col-lg-5 col-sm-6">
                      <input
                        type="text"
                        className="form-control text-black"
                        id="inputCouponCode"
                        placeholder={'Enter username'}
                        value={userName}
                        maxLength={16}
                        onChange={(e) => onChangeHandler(e)}
                      />
                      {error && (
                        <p className="errorcomes">
                          {error}
                        </p>
                      )}
                    </div>
                  </div>


                  {
                    !isemail &&
                    <div className='d-flex flex-column align-items-center mt-3'>
                      <label
                        for="inputCoutryCode"
                        className="form-label text-nowrap"
                      >
                        {`Email`}
                      </label>
                      <div className="col-lg-5 col-sm-6">

                        <input
                          type="text"
                          className="form-control text-black"
                          id="inputCouponCode"
                          placeholder="Enter email"
                          value={email}
                          maxLength={32}
                          onChange={(e) => onChangeEmail(e)}
                        />
                        {
                          erroremail && (
                            <p className="errorcomes">
                              {erroremail}
                            </p>
                          )
                        }
                      </div>
                    </div>
                  }
                  {
                    !isemail && stateList.length > 0 &&
                    (country?.dialingCode === "+91" || country?.dialingCode === "91") &&
                    <div className="d-flex justify-content-center avatar-country mt-3" style={{ zIndex: '99' }}>
                      <Select
                        className='col-lg-5 col-sm-6'
                        styles={customStyles}
                        name='stateOptionA'
                        placeholder="Select state..."
                        value={stateA} // ✅ controlled
                        options={stateList}
                        onChange={(e) => {
                          setStateA(e);
                          setStateAError('');
                        }}
                        getOptionLabel={ele => (
                          <div className="d11-menu text-black" style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{ele?.name}</span>
                          </div>
                        )}
                        isSearchable={true}
                        filterOption={stateCustomFilter}
                      />
                      {stateAError && (
                        <div className="text-danger mt-1">{stateAError}</div>
                      )}
                    </div>
                  }

                  <div className="d-flex justify-content-center avatar-country mt-3">
                    <div className="col-lg-5 col-sm-6 text-black css-b62m3t-container">
                      <div className="row">
                        <div className="col-lg-4 col-sm-5 text-black css-b62m3t-container z_9">
                          {
                            (countyId === 'null' || countyId == null && !loginType) &&
                            <div className="w-100 d-flex justify-content-center avatar-country" style={{ zIndex: '999' }}>

                              <Select
                                className="w-100 text-black"
                                styles={customStyles}
                                name="countryOption"
                                value={country || null}
                                isDisabled={isOTPVerified}
                                options={countryList}
                                onChange={(e) => {
                                  setCountry(e);
                                  setIsCountrySelected(true);
                                }}
                                isSearchable={true}
                                filterOption={customFilter}
                                getOptionLabel={ele => (
                                  <div className="d11-menu text-black" style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="icon">
                                      <img
                                        className="icon-16 me-1 d11-country-flag"
                                        src={url.imageUrl + ele?.flag?.default}
                                        alt=""
                                      />
                                    </span>{" "}
                                    <span>{ele?.dialingCode}</span>
                                  </div>
                                )}
                              />


                            </div>
                          }
                        </div>
                        <div className="col-lg-8 col-sm-7 text-black css-b62m3t-container">
                          {
                            (!isphone || isOTPVerified) && (
                              <div className="w-100 d-flex justify-content-center avatar-country">
                                <div className="w-100 position-relative phone_error">
                                  <div className="w-100 position-relative phone_error">
                                    <input
                                      type="text"
                                      className="form-control pe-5"
                                      placeholder="Enter Phone No."
                                      style={{
                                        minHeight: '32.4px',
                                        backgroundColor: (isSendClicked || isOTPVerified) ? '#f0f0f0' : '',
                                      }}
                                      value={registerInput.mobileNumber}
                                      maxLength={12}
                                      onChange={(e) => {
                                        setRegisterInput({ ...registerInput, mobileNumber: e.target.value });
                                        setPhoneError('');
                                      }}
                                      disabled={isSendClicked || isOTPVerified} // ✅ lock when verified
                                    />


                                    {isOTPVerified ? (
                                      <span
                                        className="position-absolute top-50 translate-middle-y"
                                        style={{
                                          right: '7%',
                                          transform: 'translateY(-50%)',
                                          color: 'green',
                                          fontSize: '1.25rem'
                                        }}
                                      >
                                        <img src={verifiedsvg} alt="Verified" />
                                      </span>
                                    ) : isSendClicked ? (
                                      <span
                                        className="position-absolute top-50 translate-middle-y"
                                        style={{
                                          right: '7%',
                                          transform: 'translateY(-50%)',
                                          cursor: 'pointer'
                                        }}
                                        onClick={handleEditPhone}
                                      >
                                        ✏️
                                      </span>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-primary position-absolute top-50 translate-middle-y"
                                        style={{ right: '2px', top: "calc(50% - 9.5px) !important" }}
                                        onClick={callToOTPRequestAPISignup}
                                        disabled={country?.dialingCode == "+91" ? (!registerInput.mobileNumber || registerInput.mobileNumber.length < 10) : (!registerInput.mobileNumber || registerInput.mobileNumber.length < 5)}
                                      >
                                        Send
                                      </button>
                                    )} 


                                  </div>
                                  {phoneError && (
                                    <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                      {phoneError}
                                    </div>
                                  )}
                                </div>
                              </div>

                            )
                          }</div>

                      </div>
                    </div>
                  </div>

                  {isOTPSent && !isOTPVerified && ( // ✅ also check isOTPVerified
                    <div className="d-flex justify-content-center avatar-country mt-3">
                      <div className="col-lg-5 col-sm-6 text-black css-b62m3t-container">
                        <div className="position-relative">

                          <input
                            type="text"
                            className="form-control pe-5"  // Add pe-5 for right padding so button doesn't overlap text

                            id="otpField"
                            placeholder="Enter OTP"
                            value={otp}
                            maxLength={6}
                            onChange={(e) => {
                              setOtp(e.target.value);
                              setOtpError('');
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary position-absolute top-50 translate-middle-y"


                            style={{
                              right: '2px', // adjust spacing as needed
                              backgroundColor: isOTPVerified
                                ? 'green'
                                : (!otp || otp.length < 6)
                                  ? '#070B28'
                                  : '#F92C2C',
                              borderColor: isOTPVerified
                                ? 'green'
                                : (!otp || otp.length < 6)
                                  ? '#070B28'
                                  : '#F92C2C',
                              color: isOTPVerified
                                ? '#fff'
                                : (!otp || otp.length < 6)
                                  ? 'grey'
                                  : '#fff',
                              opacity: (!otp || otp.length < 6 || isOTPVerified)
                                ? 'var(--bs-btn-disabled-opacity)'
                                : 1,
                            }}
                            disabled={!otp || otp.length < 6 || isOTPVerified}
                            onClick={handleValidateOtp}
                          >
                            {isOTPVerified ? 'Verified' : 'Verify'}
                          </button>
                        </div>

                        <div
                          className="text-black css-b62m3t-container"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >



                          {otpError && (
                            <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                              {otpError}
                            </div>
                          )}

                          <div className="mt-2">
                            <div className="text" style={{ color: 'grey', fontWeight: 'bold' }}>
                              Didn’t receive Verification Code?
                            </div>
                            {!resendAvailable ? (
                              <div>
                                <span className="text" style={{ color: 'grey', fontWeight: 'bold' }}>Resend in </span>
                                <span className="text-danger">{timer}s</span>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-link p-0 fw-bold text-danger"
                                onClick={callToOTPRequestAPISignup}
                              >
                                Resend OTP
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {
                    stateList.length > 0 &&
                    (country?.dialingCode === "+91" || country?.dialingCode === "91") &&
                    (
                      isCountrySelected ||
                      localStorage.getItem('verifiedPhoneNumber')
                    ) &&
                    <div className="d-flex justify-content-center avatar-country mt-3" style={{ zIndex: '99' }}>
                      <Select
                        className="col-lg-5 col-sm-6 text-black"
                        styles={customStyles}
                        name='stateOptionB'
                        placeholder="Select state..."
                        value={stateB}
                        options={stateList}
                        onChange={(e) => {
                          setStateB(e);
                          setStateBError('');
                        }}
                        getOptionLabel={ele => (
                          <div className="d11-menu text-black" style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{ele?.name}</span>
                          </div>
                        )}
                        isSearchable={true}
                        filterOption={stateCustomFilter}
                      />
                      {stateBError && (
                        <div className="text-danger mt-1">{stateBError}</div>
                      )}
                    </div>
                  }




                </div>

                <h4 className="mb-3 text-dark">
                  {t("login.now_choose_cool_avatar_to_go_with_your_profile")}
                </h4>
                <h4 className="mb-3 text-dark">
                  {t("login.you_can_always_change_this_or_unlock_new_ones")}
                </h4>
                <div className="row justify-content-center ">
                  <div className="col-lg-6 col-md-8 px-lg-0">
                    <div className="radioBlock">
                      <div className="radioInner">
                        {
                          avatar?.map((item, index) => (
                            item?.isBuy ?
                              <div className="form-check" key={index} >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault"
                                  id={`radio${index}`}
                                  checked={item?._id == avatarId}
                                  onChange={(e) => onClickHandler(item?._id)}
                                />
                                <label className="form-check-label" for={`radio${index}`}>
                                  <img src={url.imageUrl + item?.img?.default} alt="" style={{ width: '60px', height: '120px' }} />
                                  <span className="d-block mt-2">{item?.name}</span>
                                </label>
                              </div>
                              : ""
                          ))
                        }
                      </div>
                      {
                        avatarError && <p className='error'>{avatarError}</p>
                      }
                    </div>
                  </div>
                </div>
                {/* {console.log(countyId)} */}


                <div className="row justify-content-center mt-5">
                  <div className="col-lg-5 mt-0 col-sm-6">
                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary btn-arrow" onClick={(e) => submitHandler(e)}>
                        {t("login.submit")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

      </Modal>
      {isLoading ? <Loader /> : <></>}
    </LoginLandingPage>

  )
}

export default Avartar